import { useTranslation } from "react-i18next";
function AddNominee(){
    const { t } = useTranslation("common");
    return (
            <>{t("nominee.addNomineeText")}</>
    );
}
export default AddNominee;